import type { JSX } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Banner, IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { LINK_LEARN_MORE } from "app/pages/dashboard/helpers";

import { BannerContainer } from "./SharingModalBanner.styled";

const handleButtonClick = (): void => {
    window.open(LINK_LEARN_MORE);
};

interface ISharingModalBannerProps {
    title?: string;
    subtitle?: string;
    customButtonText?: string;
    hasCustomIcon?: boolean;
    hasCustomButton?: boolean;
    onCustomButtonClick?: () => void;
}

export const SharingModalBanner = ({
    title = translate("dashboard.shareDashboard.banner.title"),
    subtitle = translate("dashboard.shareDashboard.banner.subtitle"),
    customButtonText = translate("learn.more"),
    hasCustomIcon = false,
    hasCustomButton = false,
    onCustomButtonClick = handleButtonClick,
}: ISharingModalBannerProps): JSX.Element => {
    const renderCustomIcon = (): JSX.Element => (
        <SWReactIcons
            size="sm"
            iconName="users"
            className="icon-users"
            iconColor={colorsPalettes.indigo[300]}
        />
    );

    const renderCustomButton = (): JSX.Element => (
        <IconButton
            iconName="sparkles"
            iconSize="xs"
            onClick={onCustomButtonClick}
        >
            {customButtonText}
        </IconButton>
    );

    return (
        <BannerContainer>
            <Banner
                title={title}
                subtitle={subtitle}
                CustomIcon={hasCustomIcon ? renderCustomIcon() : null}
                CustomButton={hasCustomButton ? renderCustomButton() : null}
                className="sharing-modal-banner"
            />
        </BannerContainer>
    );
};
